import { useFeature } from "src/core/common/hooks/useFeature";
import FEATURES from "src/core/constants/features";

export const useIsExpenseCategoryEnabled = () =>
  useFeature(FEATURES.EXPENSE_CATEGORIES);
